<template lang="pug">
ul.list
  li.list-item
    .list-body
      div(style='align-items: center;display: flex; justify-content: space-between;')
        p.m-b-0 Total Cash In
        p.m-a-0.text-md._300
          a(v-if="! onLoading('fetch-summary')") {{ getFormattedCurrency(summary.total_cash_in) }}
          v-loading(loader='fetch-summary')
  li.list-item
    .list-body
      div(style='align-items: center;display: flex; justify-content: space-between;')
        p.m-b-0 Total Cash Out
        p.m-a-0.text-md._300
          a(v-if="! onLoading('fetch-summary')") {{ getFormattedCurrency(summary.total_cash_out) }}
          v-loading(loader='fetch-summary')
  li.list-item
    .list-body
      div(style='align-items: center;display: flex; justify-content: space-between;')
        p.m-b-0 Total Safe Drop
        p.m-a-0.text-md._300
          a(v-if="! onLoading('fetch-summary')") {{ getFormattedCurrency(summary.total_safe_drop) }}
          v-loading(loader='fetch-summary')

</template>

<script>
import reportFilterMixins from '../../../mixins/report-filter';
import formattedCurrencyMixins from '../../../mixins/formatted-currency';
import { mapGetters } from 'vuex';

export default {
    mixins: [reportFilterMixins, formattedCurrencyMixins],

    props: {
        day_operation_id: {
            type: String,
            required: true,
        },

        till_status: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            summary: {
                total_cash_in: null,
                total_cash_out: null,
                total_safe_drop: null,
            },
        };
    },

    mounted() {
        this.getCashAdjustmentSummary();
        this.registerReportFilterEvent();
    },

    methods: {
        getCashAdjustmentSummary() {
            this.startLoading('fetch-summary');
            let url = Laroute.route('franchise.report.till_closure.summary', {
                id: this.day_operation_id,
                status: this.till_status,
            });
            url += `?${this.filterParams}`;

            axios
                .get(url)
                .then(res => {
                    this.summary = res.data;
                    this.endLoading('fetch-summary');
                })
                .catch(err => {
                    this.showApiError(err);
                    this.endLoading('fetch-summary');
                });
        },

        registerReportFilterEvent() {
            this.$on('till-changed', val => {
                this.getCashAdjustmentSummary();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/daily-sales/cash-flow-report.vue